import { MaintenanceService } from '../../../core/services/maintenance.service';
import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { Notification, NotificationService } from '../../../core/services/notification.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faUserPlus } from '@fortawesome/pro-duotone-svg-icons/faUserPlus';
import { faMicrophone, faXmark } from '@fortawesome/pro-duotone-svg-icons';
import { IconBtn } from '../../../shared/components/ui/buttons/icon-btn/icon-btn';
import { faCheck } from '@fortawesome/pro-duotone-svg-icons/faCheck';
import { faArrowsRotate } from '@fortawesome/pro-duotone-svg-icons/faArrowsRotate';
import { TranslatePipe } from '@ngx-translate/core';
import { PATCH_NOTES_URL } from '../../../shared/constants/app-release';
import { TrialService } from '../../../core/services/trial.service';
import { LocalizedDatePipe } from '../../../shared/pipes/localized-date.pipe';
import { faHourglassHalf } from '@fortawesome/pro-duotone-svg-icons/faHourglassHalf';

@Component({
  selector: 'andor-notification',
  standalone: true,
  imports: [FaIconComponent, IconBtn, LocalizedDatePipe, TranslatePipe],
  templateUrl: './notification.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './notification.scss',
})
export class NotificationItem {
  readonly maintenance = inject(MaintenanceService);
  readonly trial = inject(TrialService);
  @Input({ required: true }) notification!: Notification;
  #notificationService = inject(NotificationService);
  protected readonly faUserPlus = faUserPlus;
  protected readonly faMicrophone = faMicrophone;
  protected readonly faXmark = faXmark;
  protected readonly faCheck = faCheck;
  protected readonly faArrowsRotate = faArrowsRotate;
  protected readonly faHourglassHalf = faHourglassHalf;
  protected readonly patchNotesUrl = PATCH_NOTES_URL;

  accept(value: boolean) {
    this.notification.onAccept?.(value);
    this.#notificationService.removeNotification(this.notification.id);
  }

  reject(value: boolean) {
    this.notification.onReject?.(value);
    this.#notificationService.removeNotification(this.notification.id);
  }

  /** Dismiss a purely informative notification (no action to take). */
  dismiss() {
    // The trial notice is permanent instance state, not a message.
    if (this.notification.type === 'trial') return;
    this.#notificationService.removeNotification(this.notification.id);
  }
}
